import React, { PureComponent, Fragment } from "react";
import ConfirmButton from "./../../../components/buttons/ConfirmButton";
import Modal from "./../../../components/modalComponent/ModalComponent";
import ImportModeleForm from "./ImportModeleForm";
import AuthRender from "../../AuthRender";
import { SERVICES, ACCESS } from "./../../../configs/constants";

class ImportUser extends PureComponent {
  state = { showModal: false, model:null };

  open(model) {
    this.setState({ showModal: true, model });
  }
  render() {
  	let title = "Importer un modèle";
  	if(this.state.model){
			title = "Edition du modèle "+this.state.model.assortmentLabel;
		}
    return (
      <AuthRender service={SERVICES.Modele} access={[ACCESS.creation]}>
        <Fragment>
          <Modal
            title={title}
            showModal={this.state.showModal}
            closeModal={() => {
              this.setState({ showModal: false });
              if (this.props.onModalClosed) {
                this.props.onModalClosed();
              }
            }}
            {...this.props}
          >
            <ImportModeleForm {...this.props} model={this.state.model}/>
          </Modal>
          <div class="p-mrg-right">
            <ConfirmButton label="Importer un modèle" large={true} onClick={() => this.setState({ showModal: true, model:null })} />
          </div>
        </Fragment>
      </AuthRender>
    );
  }
}
export default ImportUser;



// WEBPACK FOOTER //
// src/containers/admin/modeles/ImportModele.js